import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "global-search__zip" }
const _hoisted_2 = {
  key: 0,
  class: "enter-zipcode text-center mb-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "* A valid zip code is required to get estimates from nearby shops.", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "input-group-append" }
const _hoisted_6 = {
  key: 1,
  class: "spinner-border text-light spinner-border-sm",
  role: "status"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_SearchList = _resolveComponent("SearchList")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_SearchList, {
      class: "global-search-container",
      placeholder: _ctx.placeholder,
      "default-data-label": _ctx.defaultDataLabel,
      homepage: _ctx.homepage,
      "search-data": _ctx.searchData,
      "search-keys": _ctx.fuseSearchKeys,
      "show-initial-data": false,
      "hover-results": true,
      "default-data-hover": _ctx.defaultDataHover,
      "default-data": _ctx.defaultData,
      onItemSelected: _ctx.setServiceForOnramp,
      onDefaultItemSelected: _ctx.selectDefaultOption,
      onClearSelectedService: _ctx.clearSelectedService
    }, {
      lastItem: _withCtx(() => [
        _createElementVNode("button", {
          class: "list-group-item btn btn-link rounded-0",
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.defaultDataHover = true)),
          onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.defaultDataHover = false)),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToAllServices()))
        }, [
          _createTextVNode(" See all services "),
          _createVNode(_component_icon, { icon: ['fal', 'arrow-right'] })
        ], 32)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_icon, { icon: ['fal', 'map-marker-alt'] }),
          _withDirectives(_createElementVNode("input", {
            ref: "ZipcodeInput",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.zipcode) = $event)),
            name: "zipcode",
            placeholder: "ZIP Code",
            pattern: "/[0-9]{5}/g",
            maxlength: "5",
            autocomplete: "postal-code",
            inputmode: "numeric",
            class: "form-control",
            onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkGeoLocationPermission()))
          }, null, 544), [
            [_vModelText, _ctx.zipcode]
          ])
        ]),
        (_ctx.zipCodeRequired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-primary global-search__button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.startOnramp()))
          }, [
            (!_ctx.loadingTargetMarket)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          ])
        ])
      ]),
      _: 1
    }, 8, ["placeholder", "default-data-label", "homepage", "search-data", "search-keys", "default-data-hover", "default-data", "onItemSelected", "onDefaultItemSelected", "onClearSelectedService"])
  ]))
}